import React from 'react';
import { services } from '../../Data';
import { FaArrowRight } from "react-icons/fa";
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import shapeImgOne from "../../assets/images/shape-1.webp";
import shapeImgTwo from "../../assets/images/shape-2.webp";
import "./style.scss";
import { Link } from 'react-scroll';

const Services = () => {
  return (
    <>
      <section className="services section" id='services'>
        <h2 className="section__title text-cs">What I Do</h2>
        <p className="section__subtitle">
          My <span> Skills</span>
        </p>
        <Swiper
          slidesPerView={3}
          spaceBetween={30}
          pagination={{
            clickable: true,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1400: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }}
          modules={[Pagination]} className="services__container container  mySwiper">
          {services.map(({ name, title, description }, index) => {
            return (
              <SwiperSlide className="services__item card card-one" key={index}>
                <span className="services__subtitle text-cs">{name}</span>
                <h3 className="services__title">{title}</h3>
                <p className="services__description">{description}</p>

                <Link activeClass="active" className='link' to='plans' spy={true} hashSpy={true} smooth={true} offset={-150} duration={1000}>
                  See Plans
                  <FaArrowRight className='link__icon'></FaArrowRight>
                </Link>

                <img width="100%" 
              height="100%" loading='lazy' src={shapeImgTwo} alt="Cshape" className='shape c__shape' />
              </SwiperSlide>
            );
          })}
        </Swiper>

        <div className="section__deco deco__right">
          <img width="100%" 
              height="100%" loading='lazy' src={shapeImgOne} alt="shapeImg_service1" className='shape' />
        </div>

        <div className="section__bg-wrapper">
          <span className="bg__title">Service</span>
        </div>
      </section>
    </>
  )
}

export default Services;